import { APP_TYPE } from './iSpot';

interface GetISpotParmsArgs {
  utmSource?: unknown;
}

interface GetISpotParamsReturn {
  app: string;
  customData: string;
  channel: string;
}

// sending values longer than this breaks iSpots internal ETL process
const MAX_UTM_LENGTH = 255;

export function getSharedISpotParams({
  utmSource,
}: GetISpotParmsArgs): GetISpotParamsReturn {
  // utm source is defaulted to null
  const utmSourceStr =
    typeof utmSource === 'string' ? utmSource.slice(0, MAX_UTM_LENGTH) : 'null';
  const customData = `channel_${utmSourceStr}`;

  return {
    app: APP_TYPE,
    customData,
    channel: utmSourceStr,
  };
}
